import styled from '@emotion/styled';
import { Button } from 'ds/components/button';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  margin-top: ${({ theme }) => theme.spacing(3)};
`;

export const CancelButton = styled(Button)`
  border: none;

  &:hover {
    border: none;
  }
`;
